import React from "react";
import * as Icons from "lucide-react";
import { eur } from "../lib/helpers";

const r2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100;

export default function InstallmentPlanBuilder({ total, value, onChange }) {
  const rows = value || [];
  const t = parseFloat(total) || 0;

  const applyPreset = (parts) => {
    // parts: array of { label, pct }
    let acc = 0;
    const next = parts.map((p, i) => {
      let amount = i === parts.length - 1 ? r2(t - acc) : r2(t * p.pct);
      acc += amount;
      return { label: p.label, amount: amount || 0, due_date: "" };
    });
    onChange(next);
  };

  const setRow = (i, k, v) => onChange(rows.map((r, idx) => idx === i ? { ...r, [k]: v } : r));
  const addRow = () => onChange([...rows, { label: `Échéance ${rows.length + 1}`, amount: 0, due_date: "" }]);
  const delRow = (i) => onChange(rows.filter((_, idx) => idx !== i));

  const sum = rows.reduce((s, r) => s + (parseFloat(r.amount) || 0), 0);
  const diff = r2(t - sum);

  return (
    <div className="border border-marine/15 rounded-sm p-3 space-y-3" data-testid="installment-plan">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-marine">Échéancier de paiement <span className="text-xs text-marine/80 font-normal">(optionnel · modifiable ensuite)</span></span>
        {rows.length > 0 && <button type="button" onClick={() => onChange([])} data-testid="plan-clear" className="text-xs text-rouge hover:underline">Vider</button>}
      </div>

      <div className="flex flex-wrap gap-1.5">
        <button type="button" onClick={() => applyPreset([{ label: "Paiement intégral", pct: 1 }])} data-testid="preset-unique" className="text-xs px-2.5 py-1 rounded-sm border border-marine/20 text-marine hover:bg-marine-50">Paiement unique</button>
        <button type="button" onClick={() => applyPreset([{ label: "Acompte 40%", pct: 0.4 }, { label: "Solde 60%", pct: 0.6 }])} data-testid="preset-40-60" className="text-xs px-2.5 py-1 rounded-sm border border-marine/20 text-marine hover:bg-marine-50">40% / 60%</button>
        <button type="button" onClick={() => applyPreset([{ label: "Échéance 1", pct: 0.5 }, { label: "Échéance 2", pct: 0.5 }])} data-testid="preset-50-50" className="text-xs px-2.5 py-1 rounded-sm border border-marine/20 text-marine hover:bg-marine-50">50% / 50%</button>
        <button type="button" onClick={() => applyPreset([{ label: "Échéance 1", pct: 1 / 3 }, { label: "Échéance 2", pct: 1 / 3 }, { label: "Échéance 3", pct: 1 / 3 }])} data-testid="preset-3x" className="text-xs px-2.5 py-1 rounded-sm border border-marine/20 text-marine hover:bg-marine-50">3 fois</button>
      </div>

      {rows.map((r, i) => (
        <div key={i} className="flex items-center gap-2" data-testid={`plan-row-${i}`}>
          <input value={r.label} onChange={(e) => setRow(i, "label", e.target.value)} data-testid={`plan-label-${i}`} placeholder="Libellé" className="flex-1 min-w-0 border border-marine/15 rounded-sm px-2 py-1.5 text-sm" />
          <input type="number" min="0" value={r.amount} onChange={(e) => setRow(i, "amount", e.target.value)} data-testid={`plan-amount-${i}`} placeholder="€" className="w-24 border border-marine/15 rounded-sm px-2 py-1.5 text-sm" />
          <input type="date" value={r.due_date || ""} onChange={(e) => setRow(i, "due_date", e.target.value)} data-testid={`plan-date-${i}`} className="w-36 border border-marine/15 rounded-sm px-2 py-1.5 text-sm text-marine/80" />
          <button type="button" onClick={() => delRow(i)} data-testid={`plan-del-${i}`} className="p-1.5 text-marine hover:text-rouge"><Icons.Trash2 size={16} /></button>
        </div>
      ))}

      <div className="flex items-center justify-between">
        <button type="button" onClick={addRow} data-testid="plan-add" className="text-sm text-marine hover:underline inline-flex items-center gap-1"><Icons.Plus size={16} /> Ajouter une échéance</button>
        {rows.length > 0 && (
          <span className={`text-xs ${Math.abs(diff) < 0.01 ? "text-bleu" : "text-bordeaux"}`} data-testid="plan-sum">
            Total échéances : {eur(sum)}{Math.abs(diff) >= 0.01 ? ` · écart ${eur(diff)}` : " · équilibré"}
          </span>
        )}
      </div>
    </div>
  );
}
